module.exports = __webpack_public_path__ + "img/add-contact.b6781fdc.svg";